<template>
  <p style="text-align: center">
    您无权限访问此内容，请联系管理员
  </p>
</template>

<script>
export default {
  name: "noPermission"
}
</script>

<style scoped>

</style>
